import {SaleVehiclePhotoType} from '@dms/api/settings';
import i18n from '@dms/i18n';

export const getSaleVehiclePhotoTypeLabel = (photoType: SaleVehiclePhotoType) =>
  i18n.t(`entity.saleVehiclePhotoType.${photoType}`);
